import { create } from 'zustand'

export type PermissionType = {
  AppearMenu: boolean
  Code: string
  Comments: string
  Description: string
  Id: string
  MenuId: string
  Menu: string
}

type PermissionsStore = {
  permissions: PermissionType[]
  setPermissions: (permissions: PermissionType[]) => void
  hasPermission: (permissionId: string) => boolean
}

export const usePermissionsStore = create<PermissionsStore>((set, get) => ({
  permissions: [],
  setPermissions: (permissions) => set({ permissions }),
  hasPermission: (permissionId) =>
    get().permissions.some((perm) => perm.Id === permissionId),
}))

